export const ResetPasswordFinished: Page = () => {
    return <div>パスワードの再発行が完了しました!</div>
}

ResetPasswordFinished.path = "/reset_password_finished"
